import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  bannerMarkWrapper: {
    position: 'relative',
    flexShrink: 0,
  },
  bannerMark: {
    position: 'relative',
    display: 'block',
    width: 100,
    height: 100,
    backgroundImage: 'url(../images/6-a.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    zIndex: '1',
    backgroundSize: 'contain',
  },
  bannerIcon: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    display: 'block',
    width: '26px',
    height: '26px',
    backgroundColor: '#fff',
    backgroundImage: 'url(../images/icon-success.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    borderRadius: '50%',
    zIndex: '2',
    border: '1px solid #fff',
  },
})

const BannerReportAnalitycsImage = ({ classes, isConfig }) => {
  return (
    <div className={classes.bannerMarkWrapper}>
      <span className={classes.bannerMark} />
      {isConfig && <span className={classes.bannerIcon} />}
    </div>
  )
}

export default withStyles(styles)(BannerReportAnalitycsImage)
